<template>
  <BaseDialogBox
    v-model="globalStore.errorCaught"
    class="dialog-box--error"
    light
    @input="globalStore.clearErrors"
  >
    <v-card
      v-if="isDevelopment && globalStore?.errors && globalStore.errors.length > 0"
      width="700"
      max-height="550"
      flat
    >
      <div v-for="(errorObject, index) in globalStore.errors.slice(0, 1)" :key="index">
        <v-card-title class="body-1 error-header-title py-3">
          <div class="d-flex">
            <div>
              <span class="pr-2">
                <v-icon color="#059669">mdi-alert-circle-outline</v-icon>
              </span>
            </div>
            <div>
              <span class="bold" v-if="errorObject.errorType === ErrorType.Network">
                {{ getErrorTitle(errorObject) }}
              </span>
              <span class="bold" v-if="errorObject.errorType === ErrorType.Component">{{
                CONSTANTS.COMPONENT_ERROR
              }}</span>
            </div>
          </div>
        </v-card-title>
        <v-card-subtitle class="black--text mb-4 mt-4 mt-2 pb-0 error-subheader-font px-6">
          {{ errorObject?.error?.name }}
        </v-card-subtitle>
        <v-card-text v-if="errorObject?.error?.stack" class="mt-4">
          <v-expansion-panels flat focusable hover>
            <v-expansion-panel class="expansion-panel-container" style="max-height: 170px">
              <v-expansion-panel-title
                disable-icon-rotate
                class="error-header"
                @click="toggleCopyButton"
              >
                Stack Trace
                <template #actions>
                  <v-icon @click="handleCopy($event, errorObject)"> mdi-content-copy </v-icon>
                  <v-icon class="ml-5"> mdi-chevron-down </v-icon>
                </template>
              </v-expansion-panel-title>
              <div class="expansion-panel-content expansion-container-height">
                <div class="py-3">
                  <p v-if="errorObject.errorType === ErrorType.Component" class="component-header">
                    {{ errorObject.error.component }}
                  </p>
                  <p v-for="(trace, index) in errorObject?.error?.stack.split('\n')" :key="index">
                    {{ trace }}
                  </p>
                  <p v-if="errorObject.errorType === ErrorType.Component">
                    {{ errorObject?.error?.props }}
                  </p>
                  <p v-if="errorObject.errorType === ErrorType.Component">
                    {{ errorObject?.error?.classes }}
                  </p>
                </div>
              </div>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </div>
      <v-card-actions class="px-6 flex-row-reverse mt-0 mb-2 dismiss-botton-top">
        <v-btn class="dismiss-btn" elevation="0" width="90" @click="clearErrors">
          Dismiss
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      v-if="!isDevelopment && globalStore?.errors && globalStore.errors.length > 0"
      width="700"
      max-height="420"
      flat
    >
      <div v-for="(errorObject, index) in globalStore.errors.slice(0, 1)" :key="index">
        <v-card-title class="body-1 error-header-title py-3">
          <div class="d-flex">
            <div>
              <span class="pr-2">
                <v-icon color="#059669">mdi-alert-circle-outline</v-icon>
              </span>
            </div>
            <div>
              <span class="bold" v-if="errorObject.errorType === ErrorType.Network">
                {{ getErrorTitle(errorObject) }}
              </span>
              <span class="bold" v-if="errorObject.errorType === ErrorType.Component">{{
                CONSTANTS.COMPONENT_ERROR
              }}</span>
            </div>
          </div>
        </v-card-title>
        <v-card-subtitle class="black--text mb-4 mt-4 mt-2 pb-0 error-subheader-font px-6">
          {{ errorObject?.error?.name }}
        </v-card-subtitle>
      </div>
      <v-card-actions class="px-6 flex-row-reverse mt-0 mb-2 dismiss-botton-top">
        <v-btn elevation="0" class="dismiss-btn" width="90" @click="clearErrors">
          Dismiss
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-card
      v-if="globalStore?.errors && globalStore.errors.length > 0"
      width="700"
      max-height="420"
      flat
    >
      <div v-for="(errorObject, index) in globalStore.errors.slice(0, 1)" :key="index">
        <v-card-title class="body-1 error-header-title py-3">
          <div class="d-flex">
            <div>
              <span class="pr-2">
                <v-icon color="#059669">mdi-alert-circle-outline</v-icon>
              </span>
            </div>
            <div>
              <span class="bold" v-if="errorObject.errorType === ErrorType.Network">
                {{ getErrorTitle(errorObject) }}
              </span>
              <span class="bold" v-if="errorObject.errorType === ErrorType.Component">{{
                CONSTANTS.COMPONENT_ERROR
              }}</span>
            </div>
          </div>
        </v-card-title>
        <div class="black--text mb-4 mt-4 mt-2 pb-0 error-subheader-font px-6">
          {{ errorObject?.error?.name }}
        </div>
      </div>
      <v-card-actions class="px-6 flex-row-reverse mt-0 mb-2 dismiss-botton-top">
        <v-btn elevation="0" class="dismiss-btn" width="90" @click="globalStore.clearErrors">
          Dismiss
        </v-btn>
      </v-card-actions>
    </v-card> -->
  </BaseDialogBox>
</template>
<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import useGlobalStore from '@/stores/modules/global'
import ErrorType from '@/enum/ErrorType'
import { BaseDialogBox } from '@/components/base'
import { VExpansionPanel, VExpansionPanels, VExpansionPanelTitle, VBtn } from 'vuetify/components'
import CONSTANTS from '@/utils/constants/string-constants'
import { APP_ENV } from '@/utils/constants'
import { useRoute, useRouter } from 'vue-router'
import StatusCodeType from '@/enum/StatusCodeType'

const globalStore = useGlobalStore()
const copyButtonVisibility = ref(false)
const isDevelopment = computed(() => APP_ENV === 'Development')
const hasErrors = computed(() => globalStore.errors && globalStore.errors.length > 0)
const router = useRouter()
const route = useRoute()

const handleCopy = (event: Event, errorStackTrace: any) => {
  if (errorStackTrace?.error?.name && errorStackTrace?.error?.stack) {
    event.stopPropagation()

    const formattedContent = `${errorStackTrace.error.name} ${errorStackTrace.error.stack};`
    const { clipboard } = navigator
    clipboard.writeText(formattedContent)
  }
}

const toggleCopyButton = () => {
  copyButtonVisibility.value = !copyButtonVisibility.value
}

const getErrorTitle = (errorObject: any) => {
  if (errorObject?.error?.title) {
    return `Error: ${errorObject.error.title}`
  }

  return CONSTANTS.NETWORK_ERROR
}

const clearErrors = () => {
  const errorObject = globalStore.errors?.slice(0, 1)[0]
  if (errorObject.error.statusCode === (StatusCodeType.NotFound).toString()) {
    globalStore.clearErrors()
    const segments = route.path.split('/').filter(Boolean)
    if (segments[segments.length - 1] === 'edit') {
      segments.splice(-2)
    } else {
      segments.pop()
    }
    const parentPath = '/' + segments.join('/')
    router.push(parentPath)
  } else {
    globalStore.clearErrors()
  }
}
</script>

<style>
.error-header {
  border: 1px solid #e7e7e7;
  background: #f5f5f5;
  border-radius: 0;
}
.error-header-title {
  color: #000 !important;
  background: #f2f2f2;
  border-bottom: 0;
}
.component-header {
  background: #eee;
  padding: 4px 12px;
}
.dismiss-btn {
  text-transform: capitalize !important;
  background: #059669 !important;
  color: #fff !important;
  letter-spacing: 0.5px !important;
}
.dismiss-botton-top {
  padding-top: 10px !important;
}
.expansion-container-height {
  max-height: 130px;
  overflow-y: scroll;
}
.v-expansion-panel--active > .v-expansion-panel-title {
  min-height: 40px !important;
}
.error-subheader-font {
  font-size: 15px !important;
}
</style>
